import React from "react";
import { Route, Switch } from "react-router-dom";

import { ROUTES } from "../../../../routes";
import { ClientHistoryListPage } from "./list_page";

interface IProps {}

export const ClientHistoryMainPage: React.FC<IProps> = ({}) => {
  return (
    <Switch>
      <Route path={ROUTES.clientHistory} exact>
        <ClientHistoryListPage />
      </Route>
    </Switch>
  );
};
